import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL, get } from "../api";
import { BookedFlight } from "../@types";

function useFlightBooking(
  id?: string,
  options?: QueryObserverOptions<APIResponse<BookedFlight>, APIError>
) {
  const {
    isLoading: fetchingFlightBooking,
    isError: isFlightBookingError,
    data: flightBookingData,
    refetch: refreshFlightBooking,
    isFetching: isRefetchingFlightBooking,
  } = useQuery<APIResponse<BookedFlight>, APIError>(
    ["flight-booking", id],
    async () =>
      await get(`${API_URL}/aviation/flights/bookings/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    { 
      enabled: !!id,
      refetchOnWindowFocus: true, 
      ...options 
    }
  );

  const flight = flightBookingData?.data;

  return {
    fetchingFlightBooking,
    isFlightBookingError,
    flight,
    refreshFlightBooking,
    isRefetchingFlightBooking,
  };
}

export default useFlightBooking;
